<template>
  <div class="tuan">
    <img @click="handleTuan" :src="`${$ossUrl}tuan-optimization/tuanEnter.png`" alt="">
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    handleTuan () {
      this.$track.clickEvent('工作台-团油优选', '1632377031')
      this.$router.push({ path: '/tuan/tuanOptimization' })
    }
  }
}
</script>
<style lang="less" scoped>
.tuan{
  width: 100%;
  >img{
    display: block;
    width: 272px;
    height: 128px;
    cursor: pointer;
  }
}
</style>